import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'lib/stores';

export const currentUserSelector = (state: RootState) => state.auth.currentUser;

export const currentUserIsAdminSelector = createSelector(
  currentUserSelector,
  state => Boolean(state?.username === 'admin_vpdt')
);

export const currentUserIsSuperAdminSelector = createSelector(
  currentUserSelector,
  state => Boolean(state?.username === 'admin')
);
